import AppButton from './AppButton.vue'

export default AppButton
